/**
 * O'QITUVCHI ROLLARI — bitta manba.
 *
 * Tizimda o'qituvchi IKKI rolda bo'ladi: `TEACHER` va `HOMEROOM_TEACHER`
 * (sinf rahbari). Ikkinchisi ham dars beradi, ya'ni "o'qituvchi tanlash"
 * ro'yxatida u ham bo'lishi shart.
 *
 * Bu ro'yxat ayrim joylarda `role: 'TEACHER'` deb yozilgan edi va natijada
 * sinf rahbarlari TANLASH RO'YXATIDAN TUSHIB QOLARDI — 43 ta o'qituvchidan
 * 16 tasi ko'rinmasdi. Buni foydalanuvchi sezdi va aytdi.
 *
 * Shuning uchun qiymat bitta joyda turadi: keyingi safar kimdir yangi tanlash
 * ro'yxati qo'shsa, to'g'ri qiymatni yozish uchun o'ylab o'tirmaydi.
 */
export const TEACHER_ROLES = 'TEACHER,HOMEROOM_TEACHER';

/** `/staff` uchun tayyor parametr: barcha o'qituvchilar. */
export const TEACHER_PARAMS = { roles: TEACHER_ROLES } as const;
